import { render, staticRenderFns } from "./demo-events.vue?vue&type=template&id=78838790&"
import script from "./demo-events.vue?vue&type=script&lang=js&"
export * from "./demo-events.vue?vue&type=script&lang=js&"
import style0 from "./demo-events.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports